export type ChannelType = 'Facebook' | 'WebWidget' | 'WhatsApp' | 'Phone' | 'Widget';

export const ChannelTypeKeys: ChannelType[] = ['Facebook', 'WebWidget', 'WhatsApp', 'Phone', 'Widget'];

export interface Channel {
    allowOutbound: boolean;
    allowProactiveEscalation?: boolean;
    id: string;
    internalId: string;
    logo: string;
    name: string;
    tagId?: string;
    type: ChannelType;
}
